export enum ServiceTypeEnum {
  LTL = 'LTL',
  FTL = 'FTL',
  QUOTATION = 'QUOTATION',
}

export class ServiceType {
  code!: string;
  labelKey!: string;
  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_SERVICE_TYPE: { [key: string]: ServiceType } = {
  LTL: new ServiceType({ code: ServiceTypeEnum.LTL, labelKey: '' }),
  FTL: new ServiceType({ code: ServiceTypeEnum.FTL, labelKey: '' }),
  QUOTATION: new ServiceType({ code: ServiceTypeEnum.QUOTATION, labelKey: '' }),
};
